(function () {
  function qs(id) { return document.getElementById(id); }

  const zoomModal = qs("zoomModal");
  const leaveModal = qs("leaveModal");
  const zoomImg = qs("zoomImg");
  const downloadBtn = qs("downloadBtn");

  let pending = { code: null, sourceId: null };

  function openModal(el) {
    el.classList.add("open");
    el.setAttribute("aria-hidden", "false");
    document.body.classList.add("noscroll");
  }
  function closeModal(el) {
    el.classList.remove("open");
    el.setAttribute("aria-hidden", "true");
    document.body.classList.remove("noscroll");
  }

  document.addEventListener("click", (e) => {
    const close = e.target.closest("[data-modal-close]");
    if (close) {
      const m = e.target.closest(".modal");
      if (m) closeModal(m);
      return;
    }

    const img = e.target.closest("[data-zoom-img]");
    if (img) {
      const src = img.getAttribute("data-zoom-img");
      zoomImg.src = src;
      // download uses /d/{code} — код берём из URL страницы
      const code = (document.querySelector("[data-code]")?.getAttribute("data-code")) || location.pathname.split("/").pop();
      downloadBtn.href = "/d/" + code;
      openModal(zoomModal);
      return;
    }

    const srcBtn = e.target.closest(".srcbtn");
    if (srcBtn) {
      pending.code = srcBtn.getAttribute("data-code");
      pending.sourceId = srcBtn.getAttribute("data-source-id");
      const agree = qs("agree18");
      const go = qs("goExternalBtn");
      agree.checked = false;
      go.disabled = true;
      openModal(leaveModal);
      return;
    }
  });

  const agree18 = qs("agree18");
  const goExternalBtn = qs("goExternalBtn");

  if (agree18 && goExternalBtn) {
    agree18.addEventListener("change", () => {
      goExternalBtn.disabled = !agree18.checked;
    });

    goExternalBtn.addEventListener("click", () => {
      if (!pending.code || !pending.sourceId) return;
      // ВАЖНО: внешнего URL в HTML нет. Переход через внутренний редирект.
      window.location.href = `/out/${pending.code}/${pending.sourceId}?c=1`;
    });
  }
})();
